import * as React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory, History } from 'history';
import { createRoot } from 'react-dom/client';
import configureStore from './store/configureStore';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import CustomThemeProvider from "./components/Theme/CustomThemeProvider";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import Modal from './components/common/Modal';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
let history = createBrowserHistory({ basename: baseUrl });
export const store = configureStore(history);

const root = createRoot(
    document.getElementById("root") as HTMLDivElement
);

root.render(
    <Provider store={store}>
        <CustomThemeProvider>
        <BrowserRouter>
                <React.StrictMode>
                    <Modal></Modal>
                <App />
            </React.StrictMode>,
            </BrowserRouter>
        </CustomThemeProvider></Provider>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
